import { Modal, ModalContent, ModalHeader, ModalBody, Button, Textarea } from "@heroui/react";
import DirectSearchComponent, { SearchMode } from "shared/components/searchBar/components/directSearchComponent";
import { ResourceType } from "shared/types/resource";
import { useState } from "react";

interface AddBuildingContactModalProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    onSave: (data: { contactId?: number; companyId?: number; type: string; reason: string }) => void;
}

export const AddBuildingContactModal = ({ isOpen, onOpenChange, onSave }: AddBuildingContactModalProps) => {
    const [selectedResource, setSelectedResource] = useState<any>(null);
    const [reason, setReason] = useState("");

    const handleSave = () => {
        if (!selectedResource || !reason) return;

        onSave({
            contactId: selectedResource.type === ResourceType.CONTACT ? selectedResource.resourceId : undefined,
            companyId: selectedResource.type === ResourceType.COMPANY ? selectedResource.resourceId : undefined,
            type: selectedResource.type === ResourceType.CONTACT ? 'contact' : 'company',
            reason
        });

        setSelectedResource(null);
        setReason("");
    };

    return (
        <Modal 
            isOpen={isOpen} 
            onOpenChange={onOpenChange}
            size="2xl"
            classNames={{
                wrapper: "z-200",
                base: "z-200",
            }}
        >
            <ModalContent className="z-200">
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            Contact toevoegen
                        </ModalHeader>
                        <ModalBody className="px-6">
                            <div className="flex flex-col gap-4">
                                <div>
                                    <label className="mb-2 block text-sm font-medium">Contact of bedrijf</label>
                                    <DirectSearchComponent
                                        mode={SearchMode.SEARCH_AND_PRESENT}
                                        editMode={true}
                                        resourceFilter={[ResourceType.CONTACT, ResourceType.COMPANY]}
                                        onSelect={setSelectedResource}
                                        label="Zoek een contact of bedrijf..."
                                    />
                                </div>
                                <div>
                                    <label className="mb-2 block text-sm font-medium">Reden</label>
                                    <Textarea
                                        placeholder="Waarom is deze persoon/bedrijf gekoppeld aan dit gebouw?"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        minRows={3}
                                    />
                                </div>
                                <div className="flex justify-end gap-2">
                                    <Button 
                                        color="danger" 
                                        variant="light" 
                                        onPress={onClose}
                                    >
                                        Annuleren
                                    </Button>
                                    <Button 
                                        color="primary" 
                                        onPress={() => {
                                            handleSave();
                                            onClose();
                                        }}
                                        isDisabled={!selectedResource || !reason}
                                    >
                                        Toevoegen
                                    </Button>
                                </div>
                            </div>
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
}; 